// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__sc8NW","balanceDisclaimer":"posDashboard_balanceDisclaimer__1gDk6"};